import { privateClient } from "../../configs/axiosConfig";

const orderEndpoints = {
  getOrdersByOperator: "/orders/operator/:id", // ✅ corrected
};

const orderApi = {
  // Get orders by operatorId
  getOrdersByOperator: async (operatorId) => {
    try {
      const endpoint = orderEndpoints.getOrdersByOperator.replace(
        ":id",
        operatorId
      );
      const response = await privateClient.get(endpoint);
      return { response };
    } catch (err) {
      console.error("Error fetching operator orders:", err);
      return { err };
    }
  },
};

export default orderApi;
